export enum ProcedureNameEnum {
  InsertDertHeaders = "InsertDertHeaders",
  UpdateDertPayments = "UpdateDertPayments",
  GetSobitToken = "GetSobitToken",
  GetTripData = "GetTripData",
  GetHeadersWithPayments = "GetHeadersWithPayments",
  GetPaymentTypes = "GetPaymentTypes",
  GetFEConfig = "GetFEConfig",
  GetVoucherStyles = "GetVoucherStyles",
  GetGdaHeader = "GetGdaHeader",
  CreateNewVoucher = "CreateNewVoucher",
  CreateFrontendLog = "CreateFrontendLog",
  CreateEftLog = "CreateEftLog",
  CheckUser = "CheckUser",
  GetTaxList = "GetTaxList",
  GetCashMovementsSummary = "spGetCashMovementsSummary",
  GetClosingDenominations = "spGetClosingDenominations",
  GetVoucherPdf = "GetVoucherPdf",
  VoucherStatus = "VoucherStatus",
  ReturnPayment = "ReturnPayment",
  ActivateDertVoucher = "ActivateDertVoucher",
  ReportingServicesGetPDF = "ReportingServicesGetPDF",
  SendPdf = "SendPdf",
  SendVoucher = "SendVoucher",
  SetVoucherPayment = "SetVoucherPayment"
}
